import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import { useCalendly } from "@/components/CalendlyContext";

export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const { openCalendly } = useCalendly();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (location.pathname === "/contact") return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="md:hidden fixed bottom-0 inset-x-0 z-[60] p-3 bg-gradient-to-t from-black via-black/95 to-transparent"
        >
          <button
            data-testid="sticky-mobile-cta-btn"
            onClick={openCalendly}
            className="w-full bg-white text-black font-bold text-sm tracking-widest uppercase py-4 hover:bg-violet-500 hover:text-white transition-colors duration-300"
          >
            Book A Strategy Call
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
